import { createAction } from 'redux-actions';

import types from './types';

const initFaceChoice = createAction(types.INIT_FACE_CHOICE);
const setFaces = createAction(types.SET_FACES);
const startMode = createAction(types.START_MODE);
const setLoading = createAction(types.SET_LOADING);
const setMakeupProductData = createAction(types.SET_MAKEUP_PRODUCT_DATA);
const setLibraryInitialized = createAction(types.SET_LIBRARY_INITIALIZED);
const setCurrentShade = createAction(types.SET_CURRENT_SHADE);
const libraryError = createAction(types.LIBRARY_ERROR);
const modifaceError = createAction(types.MODIFACE_ERROR);
const resetModifaceError = createAction(types.RESET_MODIFACE_ERROR);
const onShadeToggle = createAction(types.ON_SHADE_TOGGLE);

export default {
    initFaceChoice,
    setFaces,
    startMode,
    setLoading,
    setMakeupProductData,
    setLibraryInitialized,
    setCurrentShade,
    libraryError,
    modifaceError,
    onShadeToggle,
    resetModifaceError,
};
